export default [
  {
    value: 'siteInfo',
    text: 'Summary'
  },
  {
    value: 'recent',
    text: 'Data Explorer'
  }
  // {
  //   value: '',
  //   text: 'Weather'
  // },
  // {
  //   value: 'historical',
  //   text: 'Data Explore'
  // },
  // {
  //   value: 'tools',
  //   text: 'Tools'
  // }
]
